import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const TicketNumbersChart = ({ monthly_tickets }: any) => {
  const labels = monthly_tickets?.map((ticket: any) => ticket?.month);
  const createdTickets = monthly_tickets?.map((ticket: any) => ticket?.created_ticket_count);
  const closedTickets = monthly_tickets?.map((ticket: any) => ticket?.closed_ticket_count);

  const data = {
    labels,
    datasets: [
      {
        label: 'Opened',
        data: createdTickets,
        backgroundColor: '#FBBF24',
      },
      {
        label: 'Closed',
        data: closedTickets, 
        backgroundColor: '#3B82F6',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, 
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          font: {
            size: 12, 
          },
        },
      },
      title: {
        display: false, 
      },
    },
    scales: {
      x: {
        grid: {
          display: false, 
        },
        ticks: {
          font: {
            size: 12, 
          },
        },
      },
      y: {
        beginAtZero: true, 
        ticks: {
          font: {
            size: 12, 
          },
        },
        grid: {
          color: '#bbb9b9', 
        },
      },
    },
  };

  return (
    <div className="p-4 border border-border rounded-lg shadow-md w-full h-100">
      <h3 className="text-lg font-semibold mb-4">Ticket Numbers</h3>
      <div className="h-74">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default TicketNumbersChart;
